/**
 * PDP Scripts — Shopify Product Detail Page
 * ─ GSAP-powered gallery slider
 * ─ Variant options hidden for single/default-title products
 * ─ Optimised for Core Web Vitals (no layout thrash, passive listeners)
 */

(function () {
  'use strict';

  /* ── tiny helpers ── */
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ── product data (already serialised by Liquid, zero extra request) ── */
  const productData = JSON.parse($('#product-json').textContent);
  const variants    = productData.variants;

  /* ── has real variants? ──────────────────────────────────────────────
     Mirror the Liquid logic so JS and template are always in sync.
     Single-option products whose only option is "Title" are treated
     as simple products — no variant UI is rendered.
  ───────────────────────────────────────────────────────────────────── */
  const hasRealVariants = (
    variants.length > 1 &&
    productData.options.length > 0 &&
    productData.options[0].toLowerCase() !== 'title'
  );

  /* ── state ── */
  let selectedOptions = {};
  let qty = 1;

  const initVariant = variants.find(v => v.available) || variants[0];
  if (hasRealVariants) {
    productData.options.forEach((_, i) => {
      selectedOptions[i] = initVariant.options[i];
    });
  }

  /* ── find matching variant ── */
  function findVariant(opts) {
    if (!hasRealVariants) return variants[0];
    return variants.find(v =>
      productData.options.every((_, i) => v.options[i] === opts[i])
    );
  }

  /* ── money formatter ── */
  const moneyFmt = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  function formatMoney(cents) {
    return '₹' + moneyFmt.format(cents / 100);
  }

  /* ── update price DOM (batched, no read-write interleave) ── */
  function updatePriceUI(variant) {
    if (!variant) return;

    const priceStr   = formatMoney(variant.price);
    const hasDisc    = variant.compare_at_price && variant.compare_at_price > variant.price;
    const compareStr = hasDisc ? formatMoney(variant.compare_at_price) : '';
    const discPct    = hasDisc
      ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)
      : 0;

    /* batch all writes into one rAF to avoid forced reflow */
    requestAnimationFrame(() => {
      $$('.sale-price').forEach(el => { el.textContent = 'Price: ' + priceStr; });

      $$('.mrp-price').forEach(el => {
        el.innerHTML = hasDisc ? '<s>' + compareStr + '</s>' : '';
      });

      $$('.discount-badge').forEach(el => {
        el.textContent   = discPct + '% off';
        el.style.display = hasDisc ? '' : 'none';
      });

      /* popup header */
      const pp = $('.popup-price');
      if (pp) pp.textContent = priceStr;
      const pc = $('.popup-compare');
      if (pc) pc.innerHTML = hasDisc ? '<s>' + compareStr + '</s>' : '';
      const pd = $('.popup-discount');
      if (pd) pd.textContent = hasDisc ? discPct + '% OFF' : '';

      $$('[data-variant-id]').forEach(el => el.setAttribute('data-variant-id', variant.id));

      updateAvailabilityUI(variant);
    });
  }

  function updateAvailabilityUI(variant) {
  const available = variant && variant.available;
  $$('.btn-atc, .btn-atc-mobile').forEach(btn => {
    if (available) {
      btn.innerHTML = btn.classList.contains('btn-atc-mobile') ? `Add to Cart` : `<svg viewBox="0 0 24 24" width="20px" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="currentColor" stroke-width="1.5"></path> <path d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="currentColor" stroke-width="1.5"></path> <path d="M2.26121 3.09184L2.50997 2.38429H2.50997L2.26121 3.09184ZM2.24876 2.29246C1.85799 2.15507 1.42984 2.36048 1.29246 2.75124C1.15507 3.14201 1.36048 3.57016 1.75124 3.70754L2.24876 2.29246ZM4.58584 4.32298L5.20507 3.89983V3.89983L4.58584 4.32298ZM5.88772 14.5862L5.34345 15.1022H5.34345L5.88772 14.5862ZM20.6578 9.88275L21.3923 10.0342L21.3933 10.0296L20.6578 9.88275ZM20.158 12.3075L20.8926 12.4589L20.158 12.3075ZM20.7345 6.69708L20.1401 7.15439L20.7345 6.69708ZM19.1336 15.0504L18.6598 14.469L19.1336 15.0504ZM5.70808 9.76V7.03836H4.20808V9.76H5.70808ZM2.50997 2.38429L2.24876 2.29246L1.75124 3.70754L2.01245 3.79938L2.50997 2.38429ZM10.9375 16.25H16.2404V14.75H10.9375V16.25ZM5.70808 7.03836C5.70808 6.3312 5.7091 5.7411 5.65719 5.26157C5.60346 4.76519 5.48705 4.31247 5.20507 3.89983L3.96661 4.74613C4.05687 4.87822 4.12657 5.05964 4.1659 5.42299C4.20706 5.8032 4.20808 6.29841 4.20808 7.03836H5.70808ZM2.01245 3.79938C2.68006 4.0341 3.11881 4.18965 3.44166 4.34806C3.74488 4.49684 3.87855 4.61727 3.96661 4.74613L5.20507 3.89983C4.92089 3.48397 4.54304 3.21763 4.10241 3.00143C3.68139 2.79485 3.14395 2.60719 2.50997 2.38429L2.01245 3.79938ZM4.20808 9.76C4.20808 11.2125 4.22171 12.2599 4.35876 13.0601C4.50508 13.9144 4.79722 14.5261 5.34345 15.1022L6.43198 14.0702C6.11182 13.7325 5.93913 13.4018 5.83723 12.8069C5.72607 12.1578 5.70808 11.249 5.70808 9.76H4.20808ZM10.9375 14.75C9.52069 14.75 8.53763 14.7482 7.79696 14.6432C7.08215 14.5418 6.70452 14.3576 6.43198 14.0702L5.34345 15.1022C5.93731 15.7286 6.69012 16.0013 7.58636 16.1283C8.45674 16.2518 9.56535 16.25 10.9375 16.25V14.75ZM4.95808 6.87H17.0888V5.37H4.95808V6.87ZM19.9232 9.73135L19.4235 12.1561L20.8926 12.4589L21.3923 10.0342L19.9232 9.73135ZM17.0888 6.87C17.9452 6.87 18.6989 6.871 19.2937 6.93749C19.5893 6.97053 19.8105 7.01643 19.9659 7.07105C20.1273 7.12776 20.153 7.17127 20.1401 7.15439L21.329 6.23978C21.094 5.93436 20.7636 5.76145 20.4632 5.65587C20.1567 5.54818 19.8101 5.48587 19.4604 5.44678C18.7646 5.369 17.9174 5.37 17.0888 5.37V6.87ZM21.3933 10.0296C21.5625 9.18167 21.7062 8.47024 21.7414 7.90038C21.7775 7.31418 21.7108 6.73617 21.329 6.23978L20.1401 7.15439C20.2021 7.23508 20.2706 7.38037 20.2442 7.80797C20.2168 8.25191 20.1002 8.84478 19.9223 9.73595L21.3933 10.0296ZM16.2404 16.25C17.0021 16.25 17.6413 16.2513 18.1566 16.1882C18.6923 16.1227 19.1809 15.9794 19.6074 15.6318L18.6598 14.469C18.5346 14.571 18.3571 14.6525 17.9744 14.6994C17.5712 14.7487 17.0397 14.75 16.2404 14.75V16.25ZM19.4235 12.1561C19.2621 12.9389 19.1535 13.4593 19.0238 13.8442C18.9007 14.2095 18.785 14.367 18.6598 14.469L19.6074 15.6318C20.0339 15.2842 20.2729 14.8346 20.4453 14.3232C20.6111 13.8312 20.7388 13.2049 20.8926 12.4589L19.4235 12.1561Z" fill="currentColor"></path> </g></svg> Add To Cart`;
    } else {
      btn.innerHTML = btn.classList.contains('btn-atc-mobile') ? `Notify Me` : `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="currentColor"></path>
                                    </svg> Notify Me`;
    }
    btn.disabled = false;
    btn.style.opacity = '';
  });
}


  /* ── variant row / pill helpers ── */
  function updateMobileVariantRow() {
    if (!hasRealVariants) return;
    $$('.mobile-variant-selector').forEach(sel => {
      const idx = parseInt(sel.dataset.optionIndex, 10);
      const el  = sel.querySelector('.mv-selected');
      if (el) el.textContent = selectedOptions[idx];
    });
  }

  function updateDesktopPills() {
    if (!hasRealVariants) return;
    $$('.variant-pill:not(.more-pill)').forEach(pill => {
      const optIdx   = parseInt(pill.dataset.option, 10);
      const value    = pill.dataset.value;
      const testOpts = { ...selectedOptions, [optIdx]: value };
      const v        = findVariant(testOpts);
      pill.classList.toggle('active',      selectedOptions[optIdx] === value);
      pill.classList.toggle('unavailable', !v || !v.available);
      pill.disabled = !v || !v.available;
    });
  }

  function updatePopupPillsForPending(pending) {
    if (!hasRealVariants) return;
    $$('.popup-pill').forEach(pill => {
      const optIdx   = parseInt(pill.dataset.option, 10);
      const value    = pill.dataset.value;
      const testOpts = { ...pending, [optIdx]: value };
      const v        = findVariant(testOpts);
      pill.classList.toggle('active',      pending[optIdx] === value);
      pill.classList.toggle('unavailable', !v || !v.available);
    });
    $$('.popup-pill-price').forEach(el => {
      const optIdx   = parseInt(el.dataset.option, 10);
      const value    = el.dataset.value;
      const testOpts = { ...pending, [optIdx]: value };
      const v        = findVariant(testOpts);
      el.textContent = v ? formatMoney(v.price) : '';
    });
  }

  function selectOption(optionIndex, value) {
    selectedOptions[optionIndex] = value;
    const variant = findVariant(selectedOptions);
    updatePriceUI(variant);
    updateDesktopPills();
    updateMobileVariantRow();
  }

  /* ── desktop pill clicks ── */
  if (hasRealVariants) {
    $$('.variant-pill:not(.more-pill)').forEach(pill => {
      pill.addEventListener('click', () => {
        selectOption(parseInt(pill.dataset.option, 10), pill.dataset.value);
      });
    });
    $$('.desktop-more').forEach(btn => btn.addEventListener('click', openPopup));
  }

  /* ============================================================
     GALLERY — GSAP sliding track
     ============================================================ */
  const track      = $('#galleryTrack');
  const slides     = $$('.main-img-slide');
  const dots       = $$('.pdp-dots .dot');
  const thumbElems = $$('.pdp-thumbs .thumb');
  let   currentIdx = 0;
  let   isAnimating = false;

  /* Wait for GSAP to be available (it's loaded with defer) */
  function waitForGSAP(cb) {
    if (typeof gsap !== 'undefined') { cb(); return; }
    const id = setInterval(() => {
      if (typeof gsap !== 'undefined') { clearInterval(id); cb(); }
    }, 20);
  }

  function goToSlide(index, instant) {
    if (!track || index === currentIdx && !instant) return;
    if (isAnimating && !instant) return;

    const total = slides.length;
    if (index < 0) index = 0;
    if (index >= total) index = total - 1;

    /* update dots / thumbs immediately (no visual cost) */
    dots.forEach((d, i) => {
      d.classList.toggle('active', i === index);
      d.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    thumbElems.forEach((t, i) => {
      t.classList.toggle('active', i === index);
      t.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    const targetX = -(index * 100) + '%';

    waitForGSAP(() => {
      /* honour prefers-reduced-motion */
      const dur = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 0.35;

      isAnimating = true;
      gsap.to(track, {
        x: targetX,
        duration: instant ? 0 : dur,
        ease: 'power2.out',
        onComplete: () => { isAnimating = false; }
      });
    });

    currentIdx = index;
  }

  /* thumbnail clicks */
  thumbElems.forEach(thumb => {
    thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.index, 10)));
  });

  /* dot clicks */
  dots.forEach(dot => {
    dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.index, 10)));
  });

  /* ── touch swipe (passive, no jank) ── */
  if (track) {
    let touchStartX  = 0;
    let touchStartY  = 0;
    let touchDeltaX  = 0;
    let isSwiping    = false;

    track.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      isSwiping   = false;
    }, { passive: true });

    track.addEventListener('touchmove', e => {
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      /* only hijack horizontal swipe (not scroll) */
      if (!isSwiping && Math.abs(dy) > Math.abs(dx)) return;
      isSwiping   = true;
      touchDeltaX = dx;
      /* live drag feedback via GSAP quickSetter for 60fps */
      waitForGSAP(() => {
        const base = -(currentIdx * 100);
        /* express delta as % of track width */
        const pct  = (dx / track.parentElement.offsetWidth) * 100;
        gsap.set(track, { x: (base + pct) + '%' });
      });
    }, { passive: true });

    track.addEventListener('touchend', () => {
      if (!isSwiping) return;
      const threshold = track.parentElement.offsetWidth * 0.2; /* 20% swipe to advance */
      if (touchDeltaX < -threshold)     goToSlide(currentIdx + 1);
      else if (touchDeltaX > threshold) goToSlide(currentIdx - 1);
      else                               goToSlide(currentIdx); /* snap back */
    }, { passive: true });
  }


  /* ============================================================
     VARIANT POPUP
     ============================================================ */
  const popupOverlay = $('#variantPopupOverlay');
  const popup        = $('#variantPopup');
  const popupClose   = $('#popupClose');
  const popupApply   = $('#popupApply');
  let   pendingOptions = {};

  function openPopup() {
    if (!popup) return;
    pendingOptions = { ...selectedOptions };
    updatePopupPillsForPending(pendingOptions);
    popupOverlay.classList.add('open');
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => popupClose && popupClose.focus(), 50);
  }

  function closePopup(apply) {
    if (!popup) return;
    if (apply) {
      selectedOptions = { ...pendingOptions };
      const v = findVariant(selectedOptions);
      updatePriceUI(v);
      updateDesktopPills();
      updateMobileVariantRow();
    }
    popupOverlay && popupOverlay.classList.remove('open');
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (hasRealVariants && popup) {
    /* popup pill clicks */
    $$('.popup-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('unavailable')) return;
        const optIdx = parseInt(pill.dataset.option, 10);
        pendingOptions[optIdx] = pill.dataset.value;
        updatePopupPillsForPending(pendingOptions);
        const pv = findVariant(pendingOptions);
        const pp = $('.popup-price');
        if (pv && pp) pp.textContent = formatMoney(pv.price);
      });
    });

    popupApply  && popupApply.addEventListener('click', () => closePopup(true));
    popupClose  && popupClose.addEventListener('click', () => closePopup(false));
    popupOverlay && popupOverlay.addEventListener('click', () => closePopup(false));

    /* mobile variant row → open popup */
    $$('.mobile-variant-selector').forEach(sel => {
      sel.addEventListener('click',  openPopup);
      sel.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPopup(); } });
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && popup.classList.contains('open')) closePopup(false);
    });
  }

  /* ── Unit toggle (KG/LB) — UI only ── */
  $$('.unit-toggle').forEach(toggle => {
    const btns = $$('.unit-btn', toggle);
    btns.forEach(btn => btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    }));
  });

  /* ============================================================
     QUANTITY — synced across desktop + mobile inputs
     ============================================================ */
  const qtyInputs = $$('.qty-input');

  function setQty(val) {
    qty = Math.min(99, Math.max(1, val));
    qtyInputs.forEach(inp => { inp.value = qty; });
  }

  $$('.qty-btn.minus').forEach(btn => btn.addEventListener('click', () => setQty(qty - 1)));
  $$('.qty-btn.plus').forEach(btn => btn.addEventListener('click',  () => setQty(qty + 1)));
  qtyInputs.forEach(inp => inp.addEventListener('change', () => setQty(parseInt(inp.value, 10) || 1)));

  /* ============================================================
     WISHLIST
     ============================================================ */
  const wishlistBtn = $('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      const wishlisted = this.getAttribute('aria-pressed') === 'true';
      this.setAttribute('aria-pressed', !wishlisted);
      const svg = this.querySelector('svg');
      svg.setAttribute('fill',   wishlisted ? 'none'    : '#e53935');
      svg.setAttribute('stroke', wishlisted ? 'currentColor' : '#e53935');
    });
  }

  /* ============================================================
     SHARE
     ============================================================ */
  $('.share-btn')?.addEventListener('click', async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: productData.title, url: location.href });
      } else {
        await navigator.clipboard.writeText(location.href);
        showToast('Link copied!');
      }
    } catch {}
  });

  /* ============================================================
     ADD TO CART / BUY NOW
     ============================================================ */
  function addToCart() {
  const variant = findVariant(selectedOptions);
  if (!variant || !variant.available) {
    if (window.NotifyModal) {
      window.NotifyModal.open('pdp-' + productData.id);
    } else {
      showToast('Please select a valid option.');
    }
    return;
  }
  fetch('/cart/add.js', { /* ...unchanged... */ });
}

function buyNow() {
  const variant = findVariant(selectedOptions);
  if (!variant || !variant.available) {
    if (window.NotifyModal) {
      window.NotifyModal.open('pdp-' + productData.id);
    } else {
      showToast('Please select a valid option.');
    }
    return;
  }
  location.href = '/cart/' + variant.id + ':' + qty;
}

  $('#desktop-atc')?.addEventListener('click', addToCart);
  $('#desktop-buy')?.addEventListener('click', buyNow);
  $('#mobile-atc')?.addEventListener('click',  addToCart);
  $('#mobile-buy')?.addEventListener('click',  buyNow);

  /* ── toast ── */
  let toastTimer;
  function showToast(msg) {
    let toast = $('#pdp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'pdp-toast';
      Object.assign(toast.style, {
        position: 'fixed', bottom: '80px', left: '50%',
        transform: 'translateX(-50%) translateY(16px)',
        background: '#1a1a1a', color: '#fff',
        padding: '10px 22px', borderRadius: '24px',
        fontSize: '14px', fontWeight: '600', zIndex: '999',
        opacity: '0', transition: 'opacity .25s, transform .25s',
        pointerEvents: 'none', whiteSpace: 'nowrap'
      });
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    clearTimeout(toastTimer);
    requestAnimationFrame(() => {
      toast.style.opacity   = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    toastTimer = setTimeout(() => {
      toast.style.opacity   = '0';
      toast.style.transform = 'translateX(-50%) translateY(16px)';
    }, 2500);
  }

  /* ============================================================
     INIT
     ============================================================ */
  (function init() {
    /* Run non-critical UI updates after first paint */
    requestIdleCallback ? requestIdleCallback(lateInit) : setTimeout(lateInit, 100);

    function lateInit() {
      if (hasRealVariants) {
        updateDesktopPills();
        updatePopupPillsForPending(selectedOptions);
        updateMobileVariantRow();
      }
      const v = findVariant(selectedOptions);
      if (v) updatePriceUI(v);
    }

    /* initialise gallery position (instant, no animation) */
    goToSlide(0, true);
  })();

})();

/* ============================================================
   LIGHTBOX
   ============================================================ */
(function () {
  'use strict';

  const lightbox   = document.getElementById('pdpLightbox');
  if (!lightbox) return;

  const lbTrack    = document.getElementById('lbTrack');
  const lbDots     = document.querySelectorAll('.lb-dot');
  const lbCounter  = document.getElementById('lbCounter');
  const lbPrev     = document.getElementById('lbPrev');
  const lbNext     = document.getElementById('lbNext');
  const lbClose    = document.getElementById('lbClose');
  const lbBackdrop = document.getElementById('lbBackdrop');

  const lbSlides   = lbTrack ? lbTrack.querySelectorAll('.lb-slide') : [];
  const total      = lbSlides.length;
  let   lbIndex    = 0;
  let   lbAnimating = false;

  if (total <= 1) lightbox.classList.add('lb-single');

  /* ── go to slide ── */
  function lbGoTo(index, instant) {
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    lbIndex = index;

    const dur = (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 0 : 0.3;

    if (typeof gsap !== 'undefined') {
      lbAnimating = true;
      gsap.to(lbTrack, {
        x: -(lbIndex * 100) + '%',
        duration: dur,
        ease: 'power2.out',
        onComplete: () => { lbAnimating = false; }
      });
    } else {
      lbTrack.style.transform = 'translateX(' + -(lbIndex * 100) + '%)';
    }

    lbDots.forEach((d, i) => d.classList.toggle('active', i === lbIndex));
    if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + total;
  }

  /* ── open / close ── */
  function openLightbox(startIndex) {
    if (!lightbox) return;
    lbGoTo(startIndex, true);
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => lbClose && lbClose.focus(), 50);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── attach open triggers to gallery images ── */
  document.querySelectorAll('.gallery-zoomable').forEach(img => {
    const slide = img.closest('.main-img-slide');
    const idx   = slide ? parseInt(slide.dataset.index, 10) : 0;
    img.addEventListener('click', () => openLightbox(idx));
    img.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(idx); } });
  });

  /* ── controls ── */
  lbClose   && lbClose.addEventListener('click', closeLightbox);
  lbBackdrop && lbBackdrop.addEventListener('click', closeLightbox);
  lbPrev    && lbPrev.addEventListener('click', () => { if (!lbAnimating) lbGoTo(lbIndex - 1); });
  lbNext    && lbNext.addEventListener('click', () => { if (!lbAnimating) lbGoTo(lbIndex + 1); });

  lbDots.forEach(dot => {
    dot.addEventListener('click', () => lbGoTo(parseInt(dot.dataset.index, 10)));
  });

  /* ── keyboard nav ── */
  document.addEventListener('keydown', e => {
    if (lightbox.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  lbGoTo(lbIndex - 1);
    if (e.key === 'ArrowRight') lbGoTo(lbIndex + 1);
  });

  /* ── touch swipe inside lightbox ── */
  let lbTouchX = 0, lbTouchDx = 0, lbSwiping = false;

  lightbox.addEventListener('touchstart', e => {
    lbTouchX  = e.touches[0].clientX;
    lbTouchDx = 0;
    lbSwiping = false;
  }, { passive: true });

  lightbox.addEventListener('touchmove', e => {
    const dx = e.touches[0].clientX - lbTouchX;
    const dy = e.touches[0].clientY - (e.touches[0]?.clientY || 0);
    if (!lbSwiping && Math.abs(dy) > Math.abs(dx)) return;
    lbSwiping = true;
    lbTouchDx = dx;
  }, { passive: true });

  lightbox.addEventListener('touchend', () => {
    if (!lbSwiping) return;
    const threshold = window.innerWidth * 0.2;
    if (lbTouchDx < -threshold)     lbGoTo(lbIndex + 1);
    else if (lbTouchDx > threshold) lbGoTo(lbIndex - 1);
  }, { passive: true });

  /* init counter */
  if (lbCounter && total > 0) lbCounter.textContent = '1 / ' + total;
})();


/* ============================================================
   PINCODE DELIVERY CHECKER
   Base pincode: 143001 (Amritsar)
   - ≤ 50 km  → 1–2 days
   - 51–300 km → 3–4 days
   - 301+ km   → 5–7 days
   All pincodes across India are valid (6-digit).
   Uses the free Pincode API to get lat/lng for distance calc.
   ============================================================ */
(function () {
  'use strict';

  /* Base warehouse coords for pin 143001 (Amritsar, Punjab) */
  const BASE_LAT = 31.6340;
  const BASE_LNG = 74.8723;

  /* Haversine distance in km */
  function haversineKm(lat1, lng1, lat2, lng2) {
    const R  = 6371;
    const dL = (lat2 - lat1) * Math.PI / 180;
    const dl = (lng2 - lng1) * Math.PI / 180;
    const a  = Math.sin(dL / 2) ** 2 +
               Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
               Math.sin(dl / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* Delivery window from distance */
  function deliveryDays(km) {
    if (km <= 50)  return { min: 1, max: 2 };
    if (km <= 300) return { min: 3, max: 4 };
    return { min: 5, max: 7 };
  }

  /* Arrival date string */
  function arrivalRange(min, max) {
    const now  = new Date();
    const opts = { weekday: 'short', month: 'short', day: 'numeric' };
    const d1   = new Date(now); d1.setDate(now.getDate() + min);
    const d2   = new Date(now); d2.setDate(now.getDate() + max);
    if (min === max) return d1.toLocaleDateString('en-IN', opts);
    return d1.toLocaleDateString('en-IN', opts) + ' – ' + d2.toLocaleDateString('en-IN', opts);
  }

  /* Attach to every pincode widget on the page */
  document.querySelectorAll('.pdp-delivery').forEach(section => {
    const input   = section.querySelector('.pincode-input');
    const btn     = section.querySelector('.pincode-check');
    const result  = section.querySelector('.pincode-result');
    const loading = section.querySelector('.pincode-loading');

    if (!input || !btn || !result) return;

    function showResult(type, html) {
      result.className = 'pincode-result show ' + type;
      result.innerHTML = html;
      if (loading) { loading.classList.remove('show'); }
    }

    async function checkPin() {
      const pin = input.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        showResult('error', '<strong>Invalid Pincode</strong>Please enter a valid 6-digit pincode.');
        return;
      }

      /* show loading state */
      result.className   = 'pincode-result';
      result.innerHTML   = '';
      if (loading) loading.classList.add('show');

      try {
        /* Free public API — no key required */
        const resp = await fetch('https://api.postalpincode.in/pincode/' + pin);
        if (!resp.ok) throw new Error('network');
        const data = await resp.json();

        if (!data || data[0].Status !== 'Success' || !data[0].PostOffice?.length) {
          showResult('error', '<strong>Pincode Not Found</strong>We deliver all across India but couldn\'t verify this pincode. Please recheck.');
          return;
        }

        const po  = data[0].PostOffice[0];
        const lat = parseFloat(po.Latitude  || '0');
        const lng = parseFloat(po.Longitude || '0');

        let days;
        if (lat && lng && lat !== 0 && lng !== 0) {
          const km = haversineKm(BASE_LAT, BASE_LNG, lat, lng);
          days     = deliveryDays(km);
        } else {
          /* API sometimes omits coordinates — default to standard window */
          days = { min: 3, max: 7 };
        }

        const arrival  = arrivalRange(days.min, days.max);
        const dayLabel = days.min === days.max
          ? days.min + ' day'
          : days.min + '–' + days.max + ' days';

        showResult(
          'success',
          '<strong>Delivery available to ' + (po.Block || po.Name) + ', ' + po.State + '</strong>' +
          'Estimated delivery in <b>' + dayLabel + '</b> (by ' + arrival + ')<br>' +
          'Free shipping &nbsp;|&nbsp; 7-day returns'
        );
      } catch {
        /* graceful fallback — still show delivery info */
        showResult(
          'success',
          '<strong>Delivery available across India</strong>' +
          'Estimated delivery in <b>3–7 days</b><br>' +
          'Free shipping &nbsp;|&nbsp; 7-day returns'
        );
      }
    }

    btn.addEventListener('click', checkPin);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') checkPin(); });
  });
})();
